import type { Category } from "types/category";
import type { SubCategory } from "types/subCategory";
import type { NoteInterface } from "types/note";
import type { BookingValidationInterface } from "types/bookingValidation";

export enum BookingStatus {
    PENDING = "PENDING",
    IN_PROGRESS = "IN_PROGRESS",
    TO_VALIDATE = "TO_VALIDATE",
    CLOSED = "CLOSED",
    CANCELLED = "CANCELLED",
}

export interface BookingUserInterface {
    gender: string;
    last_name: string;
    first_name: string;
    address: string;
    city: string;
    photo: string;
    description?: string;
    has_pet?: boolean;
    pet_type?: string[];
    user_id: string;
    num_cesu?: string;
}

export type BookingData = Record<string, unknown> & {
    device_type?: string;
    bring_products?: string;
    bring_tools?: string;
    child_count?: number | string;
    child_age?: string;
    scholar_subjects?: string[] | string;
    academic_level?: string;
    foreign_languages?: string[] | string;
    activities?: string[] | string;
};

export interface BookingInterface {
    id: string;
    code: string;
    service_id: string;
    client_id: string;
    client_address: string;
    provider_id: string;
    category: Category;
    subcategory: SubCategory;
    price: string;
    date: string;
    start_time: string;
    nb_hours: number;
    data: BookingData;
    booking_comment: string;
    cancelled_at: object;
    status: BookingStatus;
    client: BookingUserInterface;
    provider: BookingUserInterface;
    invoices_count: number;
    notes: { client: NoteInterface; provider: NoteInterface };
    booking_validation: { client: BookingValidationInterface; provider: BookingValidationInterface };
    paid: boolean;
    amount: string;
    supported_company?: string;
    created_at: object;
    updated_at: object;
    employee_contributions_ef: string;
    employer_contributions: string;
    transmitting_cesu?: string;
    cesu_plus_status?: string;
    aici_status?: string;
    activate_cesu_plus?: string;
}
